import Head from 'gatsby-theme-mdx-deck/src/components/head';
import Notes from 'gatsby-theme-mdx-deck/src/components/notes';
import customTheme from "../../../../src/style/decks-theme.js";
import { Verbatim } from "../../../../src/decks/components/deduplication.js";
import DATA from "../../../../src/decks/data/deduplication.json";
import * as React from 'react';
export default {
  Head,
  Notes,
  customTheme,
  Verbatim,
  DATA,
  React
};